<template>
  <StandardLayout>
  <v-sheet class="mx-12 my-6" rounded slot="main">
    <h1 class="outfit-regular">Guild</h1>
  </v-sheet>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'
export default {

  name: 'RealmGuild',

  components: {
    StandardLayout,
  },

}
</script>